import { createSlice } from '@reduxjs/toolkit';
import { IStoreFront } from 'interface/settingsInterface';
import { IShop } from 'interface/storeFrontCommonInterface';
export interface shopifySliceProp {
  token: string;
  shop: IShop | null;
  storeFront: IStoreFront | null;
  isRegistered: boolean;
  shopFromSearchParam?: string;
}
const initialState: shopifySliceProp = {
  token: '',
  shop: null,
  storeFront: null,
  isRegistered: false,
  shopFromSearchParam: '',
};
export const shopifySlice = createSlice({
  name: 'shopify',
  initialState,
  reducers: {
    setShopifyToken: (state, action) => {
      return { ...state, token: action.payload };
    },
    setShopifyShopDetails: (state, action) => {
      return { ...state, shop: action.payload };
    },
    setStoreFrontDetails: (state, action) => {
      return { ...state, storeFront: action.payload };
    },
    setRegistered: (state, action) => {
      return { ...state, isRegistered: action.payload };
    },
    setShopFromSearchParam: (state, action) => {
      return { ...state, shopFromSearchParam: action.payload };
    },
  },
});
// Action creators are generated for each case reducer function
export const {
  setShopifyToken,
  setShopifyShopDetails,
  setStoreFrontDetails,
  setRegistered,
  setShopFromSearchParam,
} = shopifySlice.actions;

export default shopifySlice.reducer;
